import { Component } from '@angular/core';
import { UserRoleService } from '../../services/userRole.service';
import { TileComponent } from '../../shared/components/tile/tile.component';

@Component({
  selector: 'app-start-page',
  imports: [TileComponent],
  templateUrl: './startpage.component.html',
  styleUrl: './startpage.component.scss',
  standalone: true,
})
export class StartPageComponent {
  user: string;

  constructor(protected userService: UserRoleService) {}
}
